import { Option, OptionSortingField, SortOptions } from '../types/data';

const optionsSort = <T>(options: T[], sortAlgorithm: (a: T, b: T) => number) => options.sort(sortAlgorithm);
const nonNullFieldExists = <T>(option: T, field: keyof T) =>
  typeof option[field] !== 'undefined' && option[field] !== null;

const sortByStrategy = (rawOptions: Option[], strategy: SortOptions) => {
  switch (strategy) {
    case SortOptions.ALPHABETICAL: {
      return optionsSort(rawOptions, ({ value: a }, { value: b }) => a.localeCompare(b));
    }
    case SortOptions.PARAMETERIZED: {
      return [
        ...optionsSort(
          rawOptions.filter(o => nonNullFieldExists(o, OptionSortingField)),
          ({ [OptionSortingField]: orderByA, value: valueA }, { [OptionSortingField]: orderByB, value: valueB }) => {
            if (orderByA === orderByB) {
              return valueA.localeCompare(valueB);
            }
            return orderByA.toString().localeCompare(orderByB.toString());
          },
        ),
        ...optionsSort(
          rawOptions.filter(o => !nonNullFieldExists(o, OptionSortingField)),
          ({ value: a }, { value: b }) => a.localeCompare(b),
        ),
      ];
    }

    case SortOptions.NONE:
    default:
      return rawOptions;
  }
};

export const optionsNormalize = (rawOptions: Option[], sortStrategy = SortOptions.NONE) => {
  const options = sortByStrategy(rawOptions, sortStrategy);

  return options.map(({ value }) => {
    return {
      label: value,
      value,
    };
  });
};

export const arrayToOptions = arr => arr.map(item => ({ value: item, label: item }));

export const getFirstKeyData = obj => obj[Object.keys(obj)[0]] || [];

// a piece of shitcode from old portal
export const replaceSpecialChars = (str: string, replace: Record<string, string>) => {
  let output = '';
  const keys = Object.keys(replace);
  for (let i = 0; i < str.length; i++) {
    const ascii = str
      .codePointAt(i)
      ?.toString(16)
      .toUpperCase();
    if (keys.includes(ascii)) {
      output += replace[ascii];
      if (ascii === '100001') {
        i++;
      }
    } else {
      output += str.charAt(i);
    }
  }
  return output;
};
